import Vue from 'vue'
import store from '../store/index'

Vue.filter('currency', function (value) {
  if (value === undefined || value === null)
    return 'N/A';
  return `${store.getters['app/currency']} ${(+value).toLocaleString("en-US")}`
})
